// extracted by mini-css-extract-plugin
module.exports = {"order":"_1USNQDbQ","order-label":"_3IJQkoYa","order-value":"_16YAAPl9","total":"_1e4EkC0l","total-label":"_1vDH-4xS","total-value":"_3RWgEOT_","actions":"_3D0JnlrC"};